/* =================== MODAL =================== */

// Abre o modal
function openModal(modal) {
  $("body").css("overflow", "hidden");
  $("#" + modal).addClass("open");
  $("#" + modal).trigger("modal-open");
}

// Fecha o modal
function closeModal(modal) {
  $("body").css("overflow", "auto");
  $("#" + modal).removeClass("open");
  $("#" + modal).trigger("modal-close");
}

// Abre o modal de alerta
function showAlert(titulo, mensagem, tipo) {
  $("#modal-alert").removeClass("success warning error");
  $("#modal-alert").addClass(tipo);
  $("#alert-titulo").text(titulo);
  $("#alert-texto").html(mensagem);
  openModal("modal-alert");
}

$(function () {
  // Abre o modal ao clicar no botão
  $(".modal-open").on("click", function (e) {
    e.preventDefault();
    openModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar no botão
  $(".modal-close").on("click", function (e) {
    e.preventDefault();
    closeModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar em qualquer outro lugar da tela
  $(".modal").on("click", function (e) {
    if (e.target == this && !$(this).hasClass("modal-force")) {
      closeModal($(this).attr("id"));
    }
  });

  // Fecha o modal ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      $(".modal.open")
        .not(".modal-force")
        .each(function () {
          closeModal($(this).attr("id"));
        });
    }
  });

  // Abre o modal de vídeo (Youtube)
  $(".modal-video-open").on("click", function (e) {
    e.preventDefault();
    const $el = $(this);
    openModalVideo($el.data("video-cod"), $el.data("video-tit"));
  });
  function openModalVideo(videoCod, videoTit = "") {
    const $modalVideo = $("#modal-video");
    if ($modalVideo.length) {
      const iframe = `<iframe src="https://www.youtube.com/embed/${videoCod}?rel=0&amp;showinfo=0" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>`;
      $modalVideo.find(".bloco-video-wrapper").html(iframe);
      if (videoTit != "") {
        $modalVideo.find(".bloco-video-titulo").html(videoTit);
      }
      openModal("modal-video");
    }
  }

  // Fecha o modal de vídeo (Youtube)
  $("#modal-video").on("modal-close", function () {
    $("#modal-video").find(".bloco-video-wrapper").html("");
    $("#modal-video").find(".bloco-video-titulo").html("");
  });
});
